export default __webpack_public_path__ + "maps-guides-styles-layers-sky-layer-1200-6faad9ad4d0a03ccac9b3b990a9fca61.png";